import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
const { bucketUrl, cdnUrl } = environment;

/** Servicio para la cdn */
@Injectable({
  providedIn: 'root',
})
export class Cdn {
  /**
   * Función que agrega la url de la CDN en la url relativa
   * @param url Cadena con la url de la imagen
   * @returns Devuelve cadena con la url cambiada
   */
  addUrlCDN = (url: string): string => {
    return url ? `${cdnUrl}${url}` : '';
  };

  /**
   * Función que agrega la url del bucket en la url relativa
   * @param url Cadena con la url de la imagen
   * @returns Devuelve cadena con la url cambiada
   */
  addUrlBucket = (url: string): string => {
    return url ? `${bucketUrl}${url}` : '';
  };

  /**
   * Función que modifica el ancho de una imagen
   * @param url Cadena con la url de la imagen
   * @param width Valor del ancho deseado de la imagen
   * @returns Devuelve cadena con la url cambiada
   */
  changeWidthCDN = (url: string, width: number): string => {
    return url ? `${this.addUrlCDN(url)}?w=${width}` : '';
  };

  /**
   * Función que modifica la url del bucket por la url de la CDN
   * @param url Cadena con la url de la imagen
   * @returns Devuelve cadena con la url cambiada
   */
  replaceUrlBucket = (url: string): string => {
    return url ? url.replace(bucketUrl, cdnUrl) : '';
  };

  /**
   * Función que modifica la url del bucket por la url de la CDN y agrega el ancho deseado
   * @param url Cadena con la url de la imagen
   * @param width Valor del ancho deseado de la imagen
   * @returns Devuelve cadena con la url cambiada
   */
  replaceUrlBucketWithWidth = (url: string, width: number): string => {
    return url ? `${url.replace(bucketUrl, cdnUrl)}?w=${width}` : '';
  };
}
